/* eslint-disable flowtype/no-types-missing-file-annotation */
import {ApolloTripBoardButton as TripBoardButton} from '@homeaway/react-trip-board-button';
import React from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';

import {State as ReduxState} from '../../reducers';
import {State as AbacusState} from '../../reducers/abacus';

import {ListingShape as HitListingShape} from '../Hit/Hit';

type StateProps = {
    abacus: AbacusState;
    adultsCount?: number;
    childrenCount?: number;
    isMobile?: boolean;
    endDate?: string;
    petIncluded?: boolean;
    siteName: string;
    startDate?: string;
    q?: string;
};

export type Props = {
    listing: HitListingShape;
    isMapHit?: boolean;
} & StateProps;

const TripBoardComponent = ({
    abacus,
    adultsCount,
    childrenCount,
    endDate,
    listing: {
        propertyMetadata: {headline},
        images,
        listingId,
        averageRating,
        reviewCount
    },
    isMapHit,
    isMobile,
    petIncluded,
    q: searchTerm,
    siteName,
    startDate
}: Props) => (
    <TripBoardButton
        abacus={abacus}
        adultsCount={adultsCount}
        childrenCount={childrenCount}
        endDate={endDate}
        headline={headline}
        listingId={listingId}
        searchTerm={searchTerm}
        position="left"
        rating={averageRating}
        reviewCount={reviewCount}
        petIncluded={petIncluded}
        siteName={siteName}
        startDate={startDate}
        thumbnailUrl={images && images[0] && images[0].c9_uri}
        useNativeEventListener={isMapHit}
        tabIndex={-1}
        expandedButton={!isMobile}
        redOnHover
    />
);

const mapStateToProps = (state: ReduxState): StateProps => {
    const {abacus, searchParams, system} = state;
    const {siteName, isMobile, isTablet} = system;
    const {
        arrival: startDate,
        departure: endDate,
        adultsCount,
        childrenCount,
        petIncluded,
        q
    } = searchParams.params;

    return {
        abacus,
        adultsCount,
        childrenCount,
        endDate,
        isMobile: isMobile && !isTablet,
        petIncluded,
        siteName,
        startDate,
        q
    };
};

export default compose(connect(mapStateToProps))(TripBoardComponent);
